import React, { Component } from "react";

import {
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Bar,
  Label,
  Text,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import { changeIndexToNepali } from "../../utils";
class CustomizedAxisTick extends Component {
  render() {
    const { x, y, payload } = this.props;

    return (
      <Text
        x={x}
        y={y}
        width={120}
        textAnchor="end"
        lineHeight="20px"
        verticalAnchor="middle"
      >
        {payload.value}
      </Text>
    );
  }
}

class CustomizedLabel extends Component {
  render() {
    const { x, y, fill, value } = this.props;
    return (
      <text
        x={x}
        y={y}
        dy={30}
        dx={20}
        fontSize="16"
        fontFamily="sans-serif"
        fill={fill}
        textAnchor="right"
      >{`${changeIndexToNepali(value)}%`}</text>
    );
  }
}
export default class RadarChartComponent extends Component {
  render() {
    const { data } = this.props;
    return (
      <ResponsiveContainer width="100%" height={600} className="responsive">
        <BarChart layout="vertical" data={data}>
          <CartesianGrid strokeDasharray="5 5" />
          <YAxis
            dataKey="name"
            type="category"
            tick={<CustomizedAxisTick />}
            height={100}
            width={120}
            interval={0}
          />
          <XAxis
            type="number"
            tickFormatter={(tickItem) => changeIndexToNepali(tickItem)}
          />
          {/* <Tooltip
                        // labelFormatter={() => 'abc'}
                        coordinate={(1,8)}
                        formatter={(value, name, props) => (`${changeIndexToNepali(value)}%`)}
                    /> */}
          <Legend />
          <Bar
            dataKey="score"
            fill="#82ca9d"
            label={<CustomizedLabel />}
            barSize={50}
          >
            <LabelList
              clockWise
              formatter={(value, name, props) =>
                `${changeIndexToNepali(value)}%`
              }
              dataKey="percentage"
              position="top"
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    );
  }
}
